import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import axios from 'src/app/Service/axios-dotone';

@Component({

  selector: 'app-dotone-live',

  templateUrl: './dotone-live.component.html',

  styleUrls: ['./dotone-live.component.css']

})

export class DotoneLiveComponent implements OnInit {

  message: string = '... اندکی صبر کنید ';

  constructor(private route: ActivatedRoute, private gurdService: GurdServiceService) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((params) => {

      if (params['Key']) {

        this.getUnitId(params['Key'])

      }

      if (params['timeOut']) {

        this.message = '.محدوده اعتبار زمانی این بخش به پایان رسیده است';

      }

    })

  }

  async getUnitId(key: string) {

    const key_ = key.replace(/ /g, '+').trim();

    let res = JSON.parse((await axios.post(`CheckURL`, { strKey: key_ })).data);

    // console.log(res.tiChannel)

    if (res.strUnitID) {

      this.message = '... در حال دریافت اطلاعات ';

      window.localStorage.setItem("liveKey", this.gurdService.encrypt(key_));

      window.localStorage.setItem("clientId", this.gurdService.encrypt(res.clientId));

      window.localStorage.setItem("token", this.gurdService.encrypt(res.token));

      let URL = `${res.strUnitID}?id=${res.Trip_ID}&client=${res.clientId}&map=${res.Map}&channel=${res.tiChannel}&time=${res.To}`;

      // let URL = `${'864993060620862'}?id=${'123456'}&client=${res.clientId}&map=${res.Map}&time=${res.To}`;

      window.open('/tempTracker/' + URL, "_self");

    }

    else {

      this.message = '.مشکلی پیش آمده است';

    }

  }

}
